import { Navigate , useLocation } from 'react-router-dom';
import { lazy, Suspense, ElementType } from 'react';

import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';

// Loadable component wrapper
const Loadable = (Component: ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isAuthenticated } = useAuth();

  const isDashboard = pathname.includes('/dashboard') && isAuthenticated;

  return (
    <Suspense fallback={<LoadingScreen isDashboard={isDashboard} />}>
      <Component {...props} />
    </Suspense>
  );
};

// Lazy load enhanced organization components
const EnhancedOrganizationsListPage = Loadable(
  lazy(() => import('../pages/organizations/enhanced/EnhancedOrganizationsListPage'))
);

const EnhancedOrganizationViewPage = Loadable(
  lazy(() => import('../pages/organizations/enhanced/EnhancedOrganizationViewPage'))
);

const EnhancedOrganizationEditPage = Loadable(
  lazy(() => import('../pages/organizations/enhanced/EnhancedOrganizationEditPage'))
);

const EnhancedOrganizationServiceManagement = Loadable(
  lazy(() => import('../pages/organizations/enhanced/EnhancedOrganizationServiceManagement'))
);

// Enhanced organization route configuration
export const enhancedOrganizationsRoutes = {
  path: 'organizations-enhanced',
  children: [
    {
      element: <Navigate to="/dashboard/organizations-enhanced/list" replace />,
      index: true,
    },
    {
      path: 'list',
      element: <EnhancedOrganizationsListPage />,
    },
    {
      path: ':id/view',
      element: <EnhancedOrganizationViewPage />,
    },
    {
      path: ':id/edit',
      element: <EnhancedOrganizationEditPage />,
    },
    {
      path: ':id/manage/*',
      element: <EnhancedOrganizationServiceManagement />,
    },
    // Future routes for enhanced organizations
    // { path: 'new', element: <EnhancedOrganizationCreate /> },
    // { path: ':id/settings', element: <EnhancedOrganizationSettings /> },
  ],
};

// Navigation path constants for enhanced organizations
export const ENHANCED_ORGANIZATION_PATHS = {
  root: '/dashboard/organizations-enhanced',
  list: '/dashboard/organizations-enhanced/list',
  new: '/dashboard/organizations-enhanced/new',
  view: (id: string) => `/dashboard/organizations-enhanced/${id}/view`,
  edit: (id: string) => `/dashboard/organizations-enhanced/${id}/edit`,
  settings: (id: string) => `/dashboard/organizations-enhanced/${id}/settings`,
};